// extracted by mini-css-extract-plugin
export default {"container":"styles_container__6gZj-","isAbsolute":"styles_isAbsolute__YkZFJ","item":"styles_item__f8bEK"};